import * as React from 'react';
const CrossIcon = (props: any) => {
  const { fillColor = 'currentColor', ...otherProps } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...otherProps}>
      <path
        fill={fillColor}
        // fillOpacity={0.7}
        d="m5.906 19.42-1.4-1.4 5.6-5.6-5.6-5.6 1.4-1.4 5.6 5.6 5.6-5.6 1.4 1.4-5.6 5.6 5.6 5.6-1.4 1.4-5.6-5.6-5.6 5.6Z"
      />
    </svg>
  );
};
export default CrossIcon;
